// Color schemes for pie chart rendering
// Each scheme represents a product category with specific color palettes
// Colors are ordered from darkest to lightest for automatic light/dark derivation

const SCHEME_COLORS = {
  metal: ['#5E6167', '#686D67', '#87898F', '#999999', '#9FB3AD', '#A9ABAE', '#C7C9C9', '#C7C9C9'],
  genPurp: ['#0054A6', '#0076BE', '#1C75BC', '#008FB4', '#5EAEE0', '#11BFDA', '#8CC6EC', '#BFE7F7'],
  electrical: ['#800029', '#66142E', '#B3025B', '#CE3131', '#BE1E2D', '#ED1C24', '#F6A0B3', '#F6A0B3'],
  heavyDuty: ['#633B00', '#594A42', '#7A4338', '#7A690A', '#624B00', '#884C28', '#A66F5D', '#D3A48B'],
  advancedEng: ['#006838', '#008554', '#00A651', '#00A664', '#74C699', '#8DC63F', '#808C1D', '#B9D986'],
  highTemp: ['#A54B16', '#DF6020', '#F26522', '#F6891F', '#FAAB54', '#FAAE7A', '#F8A48D', '#FFCE51'],
  specialty: ['#522E91', '#741D66', '#7F3F98', '#8266AC', '#9D3F97', '#B93E97', '#687CBD', '#BAA0CC']
}

/**
 * Build color scheme object from color array
 * Automatically assigns colors to letters A-H and derives light/dark variants
 */
function buildColorScheme(colors) {
  const scheme = {}
  
  // Map colors to letters A-H
  colors.forEach((color, index) => {
    scheme[String.fromCharCode(65 + index)] = color
  })
  
  // Automatically derive light/dark from array (first is darkest, last is lightest)
  scheme.light = colors[colors.length - 1]
  scheme.dark = colors[0]
  
  return scheme
}

// Build and export color schemes
export const COLOR_SCHEMES = Object.entries(SCHEME_COLORS).reduce((acc, [key, colors]) => {
  acc[key] = buildColorScheme(colors)
  return acc
}, {})

/**
 * Get color scheme by name
 * @param {string} schemeName - The name of the color scheme
 * @returns {Object|undefined} Color scheme object with A-H properties and light/dark variants
 */
export function getColorScheme(schemeName) {
  return COLOR_SCHEMES[schemeName]
}
